import type { ApiErrorResult, RecordType } from "../types/api";

const ApiError = (status: number, message: string, details?: RecordType): ApiErrorResult => {
  const error = new Error(message) as ApiErrorResult;
  error.name = "ApiError";
  error.status = status;
  error.details = details;
  return error;
};

export { ApiError };
